import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface JasperIframe {
    isOpen: boolean;
    url: string;
}
const initialState: JasperIframe = {
    isOpen: false,
    url: '',
};
const JasperIframeSlice = createSlice({
    name: 'JasperIframe',
    initialState,
    reducers: {
        setJasperIframeOpen: (state, action: PayloadAction<any>) => {
            state.isOpen = action.payload.isOpen;
            state.url = action.payload.url;
        },
    },
});

export const { setJasperIframeOpen } = JasperIframeSlice.actions;
export default JasperIframeSlice.reducer;
